import React, { useEffect, useState } from 'react'

import { Icon } from '../../../components/Icon'
import {
  IncidentsHeaders,
  policyHeader,
} from '../../../data/index'
import Menu from '../../../components/UI/UIMenu'
import Modal from '../../../components/UI/UIModal'
import UITextArea from '../../../components/UI/UITextArea'
import UISubHeaderComponent from '../../../components/UI/UISubHeaderComponent'
import '../../../App.css'
import UiSelect from '../../../components/UI/UISelect'

import { useQuery } from 'react-query'
import {
  getIncidents,
  initialData,
} from './apiCalls'
import { incident, incidentData } from '../../../utils/types'
import { addIncident } from '../../../api/candidate/incidents'
import { toast } from 'react-toastify'
import {
  capitalizeFirstLetter,
  formatDate,
  statusBgColorWhistleblowing,
} from '../../../utils/utils'
import Loading from '../../../components/UI/Loading'
import { SeverityIcon } from '../../incidents/utils'
import UITextInput from '../../../components/UI/UITextInput'
import { checkValidation } from './utils'

interface incidents {
  Report_No: number
  Status: string
  Severity_Level: string
  Incident_concerning: string
  Name_of_Employer: string
  Date_Reported: string
  Updated_At: string
  Created_By: string
  Updated_By: string
}
export interface FormData {
  candidate: string
  employer: string
  severity_level: string
  overview: string
  status: string
}

const IncidentsCandidate = () => {
  const [formData, setFormData] = useState<FormData | incidentData>(initialData)
  const [incidentViewData, setIncidentViewData] = useState<incident>()
  const [isOpen, setIsOpen] = useState(false)
  const [isView, setIsView] = useState(false)
  const [isEdit] = useState(false)
  const [sortOrder, setSortOrder] = useState<{
    [key: string]: 'asc' | 'desc'
  }>({})
  const [sortBy, setSortBy] = useState<string>('reportNo')
  const [sortOrderValue, setSortOrderValue] = useState<string>('asc')

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { data, isLoading, isError, refetch } = useQuery('incidents', () =>
    getIncidents(sortBy, sortOrderValue)
  )

  const [isOpenMenu, setIsOpenMenu] = useState<boolean[]>(
    new Array(data?.data?.length || 100).fill(false)
  )

  const handleSort = (key: string) => {
    const newSortOrder = { ...sortOrder }
    if (newSortOrder[key] === 'asc' || newSortOrder[key] === undefined) {
      newSortOrder[key] = 'desc'
      setSortBy(key)
      setSortOrderValue('desc')
    } else {
      newSortOrder[key] = 'asc'
      setSortBy(key)
      setSortOrderValue('asc')
    }
    setSortOrder(newSortOrder)
  }

  useEffect(() => {
    refetch() // Refetch incidents when sortBy or sortOrderValue changes
  }, [sortBy, sortOrderValue])

  const handleToggleMenu = (rowIndex: number) => {
    const updatedMenuState = isOpenMenu.map((isOpen, index) =>
      index === rowIndex ? !isOpen : false
    )
    setIsOpenMenu(updatedMenuState)
  }

  const handleOpenModal = () => {
    setIsOpen(true)
  }

  const handleCloseModal = () => {
    setIsOpen(false)
  }

  const handleChange = (fieldName: string, value: string): void => {
    setFormData((prevState) => ({
      ...prevState,
      [fieldName]: value,
    }))
  }

  const createNewIncident = async (): Promise<void> => {
    const response = (await addIncident(formData)) as {
      status?: string
      data: incidentData
    }
    if (response?.status == 'successful') {
      refetch()
      handleCloseModal()
      setFormData(initialData)
      toast.success('Incident Created.', {
        position: 'top-right',
      })
    } else {
      toast.error('Network Error.', {
        position: 'top-right',
      })
    }
  }

  return (
    <div
      className={
        'flex flex-col gap-3 w-full bg-white  h-full rounded-3xl p-8  '
      }
    >
      {!isView && (
        <div className="flex flex-col gap-5 w-full relative h-full">
          <div className={'flex w-full justify-between items-start '}>
            <div className="flex-col w-[50%] gap-[20px]">
              <p className={'text-[18px] text-text2 font-bold '}>Incidents</p>
            </div>

            <div className={'flex flex-row gap-[15px]'}>
              <div
                onClick={() => {
                  handleOpenModal()
                }}
                className="gap-[10px]  bg-bluishGreen items-center justify-between min-w-[95px] text-white h-12 px-[20px] flex rounded-[72px] cursor-pointer"
              >
                <p className={'font-medium text-[14px] text-white'}>
                  Create Report
                </p>
                <Icon
                  name={'IconPlus'}
                  strokeWidth={1}
                  stroke={'white'}
                  width={16}
                  height={16}
                />
              </div>
            </div>
          </div>
          {isLoading && (
            <div className="flex justify-center items-center h-screen">
              <Loading size="large" />
            </div>
          )}

          {!isLoading && (
            <>
              <div
                id={'#container'}
                className="w-full flex justify-center items-center"
              >
                {/* table component */}
                <div className="overflow-hidden rounded-[16px] w-full">
                  <table className="rounded-[16px] overflow-hidden border w-full border-white">
                    <thead>
                      <tr className="bg-gray2 cursor-pointer">
                        {IncidentsHeaders?.map((item, index: number) => {
                          return (
                            <th
                              key={index}
                              className={`w-1/8 px-4 py-3 text-left ${policyHeader?.length - 1 === index ? 'border-0 border-gray2' : 'border border-white'}`}
                            >
                              <div className="flex items-center">
                                <p className="text-text1 font-semibold text-sm flex-1">
                                  {item.replace(/_/g, ' ')}
                                </p>
                                <div
                                  onClick={() => {
                                    let sortBy = ''
                                    switch (item as keyof incidents) {
                                      case 'Report_No':
                                        sortBy = 'reportNo'
                                        break
                                      case 'Status':
                                        sortBy = 'status'
                                        break
                                      case 'Severity_Level':
                                        sortBy = 'severity_level'
                                        break
                                      case 'Incident_concerning':
                                        sortBy = 'candidate'
                                        break
                                      case 'Name_of_Employer':
                                        sortBy = 'employer'
                                        break
                                      case 'Date_Reported':
                                        sortBy = 'createdAt'
                                        break
                                      case 'Updated_By':
                                        sortBy = 'updatedByName'
                                        break
                                      case 'Updated_At':
                                        sortBy = 'updatedAt'
                                        break

                                      default:
                                        break
                                    }
                                    handleSort(sortBy)
                                  }}
                                >
                                  <Icon
                                    name={'IconChevronDown'}
                                    width={16}
                                    height={16}
                                    strokeWidth={1}
                                    stroke={'#67A5B9'}
                                  />
                                </div>
                              </div>
                            </th>
                          )
                        })}
                        <th className="w-1/8 px-4 py-3 border text-left border-white"></th>
                      </tr>
                    </thead>
                    <tbody>
                      {data?.data?.map((item, index) => (
                        <>
                          <tr className="bg-gray1">
                            <td className="px-4 text-text1 font-medium text-[12px] h-[48px] py-2 border border-white">
                              {item.reportNo}
                            </td>
                            <td className="px-4 h-[48px] py-2 border border-white">
                              <div
                                className={`px-[10px] flex justify-center items-center bg-${statusBgColorWhistleblowing(item.status)} h-[28px] rounded-[100px]`}
                              >
                                <p className="text-text2 font-medium text-xs leading-5">
                                  {capitalizeFirstLetter(item.status || '')}
                                </p>
                              </div>
                            </td>
                            <td className="px-4 min-w-[140px] h-[48px] py-2 border border-white">
                              <SeverityIcon
                                severity_level={item.severity_level}
                              />
                            </td>
                            <td className="px-4 text-text1 font-medium text-[12px] h-[48px] py-2 border border-white">
                              <p className="text-xs text-text1 font-medium leading-5">
                                {item.candidate}
                              </p>
                            </td>
                            <td className="px-4 text-text1 font-medium text-[12px] h-[48px] py-2 border border-white">
                              <p className="text-xs text-text1 font-medium leading-5">
                                {item.employer}
                              </p>
                            </td>
                            <td className="px-4 text-text1 font-medium text-[12px] h-[48px] py-2 border border-white">
                              {formatDate(item.createdAt)}
                            </td>

                            <td className="px-4 h-[48px] py-2 border border-white">
                              {item.updatedByName ? (
                                <p className="text-xs text-text1 font-medium">
                                  {item.updatedByName}
                                </p>
                              ) : (
                                <p className="text-xs text-text1 font-medium">
                                  {/* Awaiting Update */}
                                </p>
                              )}
                            </td>
                            <td className="px-4 text-xs text-text1 font-medium leading-5 h-[48px] py-2 border border-white">
                              {item.updatedByName ? (
                                <p className="text-xs text-text1 font-medium">
                                  {formatDate(item.updatedAt)}
                                </p>
                              ) : (
                                <p className="text-xs text-text1 font-medium">
                                  {/* Awaiting Update */}
                                </p>
                              )}
                            </td>
                            <td className="px-4  py-2 border border-white cursor-pointer flex items-center h-[65px] justify-center">
                              <Menu
                                isOpen={isOpenMenu[index]}
                                items={[
                                  {
                                    label: 'View',
                                    onClick: () => {
                                      handleToggleMenu(index)
                                      setIsView(true)
                                      setIncidentViewData(item)
                                    },
                                    icon: 'IconEye',
                                    iconColor: '',
                                  },
                                ]}
                                setIsOpenMenu={setIsOpenMenu}
                                isOpenMenus={isOpenMenu}
                                type={'table'}
                              >
                                <div onClick={() => handleToggleMenu(index)}>
                                  <Icon
                                    name={'IconDotsVertical'}
                                    width={16}
                                    height={16}
                                    strokeWidth={1.5}
                                    stroke={'#02698C'}
                                  />
                                </div>
                              </Menu>
                            </td>
                          </tr>
                        </>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </>
          )}

          {/* <div className="absolute bottom-[20px]">

            <Pagination
              currentPage={currentPage}
              totalPages={calculatePageCount(Number(data?.count) || 0)}
              onPageChange={handlePageChange}
            />
          </div> */}
        </div>
      )}
      {isView && (
        <div style={{ height: 'calc(100vh - 100px)', overflow: 'auto' }}>
          <UISubHeaderComponent
            mainPage="Incidents"
            subPage={`Incident Report No. ${incidentViewData?.reportNo}`}
            copy=""
            isViewMode={false}
            onBack={() => {
              setIsView(false)
            }}
          />

          {/* content container */}
          <div className="overflow-hidden rounded-[16px] w-full  my-[30px]">
            <table className="rounded-[16px] overflow-hidden border w-full border-white">
              <tbody>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Report ID
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    {incidentViewData?.reportNo}
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Status
                  </td>
                  <td className="px-4 h-[48px] py-2 border border-white">
                    <div
                      className={`bg-${statusBgColorWhistleblowing(incidentViewData?.status)} w-fit px-3 py-2 rounded-2xl`}
                    >
                      <p className="text-xs font-medium leading-5 text-text2">
                        {capitalizeFirstLetter(incidentViewData?.status || '')}
                      </p>
                    </div>
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Severity Level
                  </td>
                  <td className="px-4 h-[48px] py-2 border border-white">
                    <SeverityIcon
                      severity_level={incidentViewData?.severity_level || ''}
                    />
                  </td>
                </tr>
                <tr className="bg-gray1">
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Incident Concerning
                  </td>
                  <td className="px-4 h-[48px] py-2 border border-white">
                    <div className="flex gap-2 bg-gray2 rounded-xl px-4 py-3  w-fit ">
                      <Icon
                        name={'IconUserCircle'}
                        stroke="#3487A2"
                        width={16}
                        height={16}
                      />
                      <p className="text-xs font-medium leading-5 text-text1">
                        {incidentViewData?.candidate}
                      </p>
                    </div>
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Name of Employer
                  </td>
                  <td className="px-4 h-[48px] py-2 border border-white">
                    <div className="flex gap-2 bg-gray2 rounded-xl px-4 py-3  w-fit ">
                      <Icon
                        name={'IconBuilding'}
                        stroke="#3487A2"
                        strokeWidth={3.67}
                        width={16}
                        height={16}
                      />
                      <p className="text-xs font-medium leading-5 text-text1">
                        {incidentViewData?.employer}
                      </p>
                    </div>
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Overview of Concern
                  </td>
                  <td className="px-4 h-[48px] py-2 border border-white text-sm font-semibold leading-6 text-text5">
                    {incidentViewData?.overview}
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Created By
                  </td>
                  <td className="px-4 h-[48px] py-2 border border-white">
                    <div className="flex gap-2 bg-gray2 rounded-xl px-4 py-3  w-fit ">
                      <Icon
                        name={'IconUserCircle'}
                        stroke="#3487A2"
                        width={16}
                        height={16}
                      />
                      <p className="text-xs font-medium leading-5 text-text1">
                        {incidentViewData?.createdByName}
                      </p>
                    </div>
                  </td>
                </tr>
                <tr className="bg-gray1">
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Date Received
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    {incidentViewData?.createdAt?.substring(0, 16)}
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Date Reported
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    {incidentViewData?.createdAt?.substring(0, 16)}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="overflow-hidden rounded-[16px] w-full mb-8">
            <table className="rounded-[16px] overflow-hidden border w-full border-white">
              <tbody>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Updated By
                  </td>
                  <td className="px-4 h-[48px] py-2 border border-white">
                    {incidentViewData?.updatedByName ? (
                      <div className="flex gap-2 bg-gray2 rounded-xl px-4 py-3  w-fit ">
                        <Icon
                          name={'IconUserCircle'}
                          stroke="#3487A2"
                          width={16}
                          height={16}
                        />
                        <p className="text-xs font-medium leading-5 text-text1">
                          {incidentViewData?.updatedByName}
                        </p>
                      </div>
                    ) : (
                      <p className="text-text1 font-semibold text-[14px] leading-6">
                        Awaiting Update
                      </p>
                    )}
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Updated On
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    {incidentViewData?.updatedAt?.substring(0, 16)}
                  </td>
                </tr>

                {/* Add more rows as needed */}
              </tbody>
            </table>
          </div>
        </div>
      )}
      {/* modal */}
      <Modal
        customStyle={{ borderRadius: 16 }}
        isOpen={isOpen}
        onClose={handleCloseModal}
      >
        <div
          className={
            'w-[480px] max-h-[80vh] overflow-scroll custom-scrollbar items-center  p-4 flex flex-col gap-4'
          }
        >
          <div
            onClick={handleCloseModal}
            className="flex w-[100%] justify-end cursor-pointer"
          >
            <Icon name={'IconCross'} stroke="#02698C" height={16} width={16} />
          </div>
          <div className="flex items-center w-[100%] justify-center">
            <Icon
              name={'IconAlertTriangle'}
              stroke={'#02698C'}
              strokeWidth={0.5}
              height={56}
              width={56}
            />
          </div>
          <div className="flex flex-col gap-2 items-center w-[100%] justify-center">
            <h1 className={'text-text2 text-[18px] font-bold'}>
              {isEdit ? 'Edit Incident Report' : 'Create Incident Report'}
            </h1>
            <p className={'text-[14px] text-text1 font-normal'}>
              Please enter the details of the incident
            </p>
          </div>
          {/* <div className="w-[100%] justify-between flex mt-[10px]">
            <UiSelect
              options={[
                { value: 'report1', label: 'Report 1' },
                { value: 'report2', label: 'Report 2' },
              ]}
              title={'Report Name'}
            />
          </div> */}
          <div className="w-[100%] gap-[15px] justify-between mt-[10px] flex">
            <div className="w-[100%]  ">
              <UITextInput
                placeholder={''}
                label={'Incident Concerning*'}
                iconName={''}
                onChange={(e) => {
                  handleChange('candidate', e.target.value)
                }}
                value={formData.candidate}
              />
            </div>
            <div className="w-[100%]  ">
              <UITextInput
                placeholder={''}
                label={'Name of Employer'}
                iconName={''}
                onChange={(e) => {
                  handleChange('employer', e.target.value)
                }}
                value={formData.employer}
              />
            </div>
            {/* <UiSelect
              options={convertedData || []}
              title={'Name of Candidate*'}
              onChange={(e) => {
                handleChange('candidate', e)
              }}
              value={formData.candidate}
            /> */}
            {/* <UiSelect
            disabled={true}
              options={[
               
              ]}
              title={'Name of Employer*'}
           
            
            /> */}
          </div>
          <div className="w-[100%] flex">
            <UiSelect
              options={[
                { value: 'minor', label: 'minor' },
                { value: 'serious', label: 'serious' },
                { value: 'well-being', label: 'well-being' },
              ]}
              onChange={(e) => {
                handleChange('severity_level', e)
              }}
              value={formData.severity_level}
              title={'Severity Level*'}
            />
          </div>
          <div className="w-[100%] flex mt-1">
            <UITextArea
              label={'Overview of Concern Raised*'}
              onChange={(e) => {
                handleChange('overview', e.target.value)
              }}
              value={formData.overview}
              onBlur={() => {}}
              placeholder="Please enter your Description"
              iconName={'none'}
              rows={5}
            />
          </div>
          {isEdit ? (
            <button
              onClick={handleOpenModal}
              className="bg-bluishGreen text-white min-h-[48px] w-[100%] font-medium rounded-[72px] text-[14px] mt-4"
            >
              Update
            </button>
          ) : (
            <button
              disabled={checkValidation(formData)}
              onClick={() => {
                createNewIncident()
              }}
              className=" disabled:bg-gray1 bg-bluishGreen text-white min-h-[48px] w-[100%] font-medium rounded-[72px] text-[14px] mt-4"
            >
              Create
            </button>
          )}
        </div>
      </Modal>
    </div>
  )
}

export default IncidentsCandidate
